import { render, staticRenderFns } from "./SpireFtpPreviewModal.vue?vue&type=template&id=97e087b4"
import script from "./SpireFtpPreviewModal.vue?vue&type=script&lang=js"
export * from "./SpireFtpPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports